import React from "react";

import { graphql } from "gatsby";

import MediaQuery from "cms/components/MediaQuery";
import RichText from "cms/components/RichText";
import BackgroundImageMobile from "cms/images/grid-mobile.png";
import BackgroundImageTabletAndDesktop from "cms/images/grid-tablet-and-desktop.png";
import OptimizedVideo from "index";

import {
  Container,
  Content,
  Message,
  Pitch,
  IllustrationContainer,
  VideoContainer,
  VideoFrame,
  YoutubeIframe,
  CloseButton,
  BackgroundGradient,
  BackgroundImage,
} from "./AutodesignerVideoHeroBanner.styles";
import Text from "cms/components/Text";

export interface AutodesignerVideoHeroBannerProps
  extends Queries.SanityAutodesignerVideoHeroBanner {}

const AutodesignerVideoHeroBanner: React.FC<AutodesignerVideoHeroBannerProps> =
  ({
    title,
    _rawPitch,
    videoURL,
    videoForMobile,
    videoForMobileAlt,
    videoForTabletAndDesktop,
    videoForTabletAndDesktopAlt,
  }) => {
    const [showVideo, setShowVideo] = React.useState(false);

    const handleOpenVideo = () => {
      setShowVideo(true);
    };

    const handleCloseVideo = () => {
      setShowVideo(false);
    };
    return (
      <Container>
        <Content>
          <Message>
            <Text variant="D1" as="h1" textAlign="center" weight="regular">
              {title}
            </Text>
            <Pitch>
              <RichText text={_rawPitch} />
            </Pitch>
          </Message>
          <MediaQuery $lessThan="medium" style={{ width: "100%" }}>
            {videoForMobile && (
              <IllustrationContainer onClick={handleOpenVideo}>
                <OptimizedVideo
                  video={videoForMobile}
                  alt={videoForMobileAlt}
                />
              </IllustrationContainer>
            )}
          </MediaQuery>

          <MediaQuery $greaterThan="medium" style={{ width: "100%" }}>
            {videoForTabletAndDesktop && (
              <IllustrationContainer onClick={handleOpenVideo}>
                <OptimizedVideo
                  video={videoForTabletAndDesktop}
                  alt={videoForTabletAndDesktopAlt}
                />
              </IllustrationContainer>
            )}
          </MediaQuery>
        </Content>

        {showVideo && videoURL && (
          <VideoContainer>
            <CloseButton
              onClick={handleCloseVideo}
              style={{ position: "absolute", top: "0", right: "0" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 12 12"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line
                  x1="1"
                  y1="11"
                  x2="11"
                  y2="1"
                  stroke="white"
                  strokeWidth="2"
                />
                <line
                  x1="1"
                  y1="1"
                  x2="11"
                  y2="11"
                  stroke="white"
                  strokeWidth="2"
                />
              </svg>
            </CloseButton>

            <VideoFrame>
              <MediaQuery $lessThan="medium" style={{ width: "100%" }}>
                <YoutubeIframe
                  width={Math.round(
                    window.innerWidth - window.innerWidth * 0.2,
                  )}
                  height={Math.round(
                    (window.innerWidth - window.innerWidth * 0.2) / (1 / 1),
                  )}
                  src={videoURL}
                  title="The Autodesigner 1.5 Update is Here!"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  $allowfullscreen
                />
              </MediaQuery>
              <MediaQuery $greaterThan="medium" style={{ width: "100%" }}>
                <YoutubeIframe
                  width={Math.round(
                    window.innerWidth - window.innerWidth * 0.2,
                  )}
                  height={Math.round(
                    (window.innerWidth - window.innerWidth * 0.2) / (16 / 9),
                  )}
                  src={videoURL}
                  title="The Autodesigner 1.5 Update is Here!"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  $allowfullscreen
                />
              </MediaQuery>
            </VideoFrame>
          </VideoContainer>
        )}

        <BackgroundGradient />

        <MediaQuery $lessThan="medium" style={{ width: "100%" }}>
          <BackgroundImage src={BackgroundImageMobile} alt="white grid" />
        </MediaQuery>

        <MediaQuery $greaterThan="medium" style={{ width: "100%" }}>
          <BackgroundImage
            src={BackgroundImageTabletAndDesktop}
            alt="white grid"
          />
        </MediaQuery>
      </Container>
    );
  };

export const query = graphql`
  fragment AutodesignerVideoHeroBanner on SanityAutodesignerVideoHeroBanner {
    _key
    _type
    title
    _rawPitch(resolveReferences: { maxDepth: 5 })
    videoURL
    videoForMobile { ...OptimizedVideo }
    videoForMobileAlt
    videoForTabletAndDesktop { ...OptimizedVideo }
    videoForTabletAndDesktopAlt
  }
`;

export default AutodesignerVideoHeroBanner;
